import { ViewBoxNS } from "../../../../../../ViewBox/ViewBoxNS.js";
export const setViewBox = (self, view_box_vo) => {
  self._checkNoProcessingTask();
  const view_box = self._getViewBoxThrowable();
  view_box.setViewBox(view_box_vo);
};
